import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useLocation } from 'react-router-dom';

const PoojaPaymentCancel = () => {
  const location = useLocation();
  const [message, setMessage] = useState('Your payment was not completed. No charge has been made.');

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const orderNumber = params.get('order_number');
    if (!orderNumber) return;

    axios
      .delete(`${process.env.REACT_APP_API_BASE_URL}/api/punditpurohit/orders/payment-cancel`, {
        params: { orderNumber },
      })
      .then(() => setMessage('Your pending booking has been cancelled. No charge has been made.'))
      .catch((err) => {
        console.error('Unable to cancel pending pooja payment', err);
        setMessage('Payment was not completed. If you need help, please contact support.');
      });
  }, [location.search]);

  return (
    <div className="orders-page-wrapper">
      <div className="orders-container">
        <header className="orders-header">
          <div>
            <p className="drawer-eyebrow">Secure Checkout</p>
            <h1>Payment Incomplete</h1>
          </div>
        </header>
        <div className="checkout-panel">
          <p>{message}</p>
          <Link className="primary-btn checkout-btn" to="/uc/panditpurshothit">Return to Poojas</Link>
        </div>
      </div>
    </div>
  );
};

export default PoojaPaymentCancel;
